<template>
	<div class="pop_conditions" style="display: block">
		<div class="popup_close close_cond close-animate">
			<a href="javascript:void(0);" @click.prevent="closeModal">
				<Close />
			</a>
		</div>
		<div class="pop_frame">
			<h2 class="title25">{{ data.heading }}</h2>
			<div class="text">
				{{ data.content }}
			</div>
			<div class="bt_green ease">
				<a href="javascript:void(0);" @click.prevent="closeModal">{{ data.button_text }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import Close from "../../../assets/img/close.svg";
	export default {
		data() {
			return {};
		},
		computed: {
			data() {
				try {
					return window.wpData.globalOptions.office_core_settings.slots_failed_popup;
				} catch (error) {
					return {
						heading: "אופס!",
						content: "משהו השתבש",
						button_text: "אוקיי... אני אנסה שוב"
					};
				}
			}
		},
		mounted() {
			try {
				window.dataLayer.push({
					event: "ga_event",
					category: "checkout",
					action: "get_coordinates",
					label: "failed"
				});
			} catch (err) {}
		},
		methods: {
			closeModal() {
				let redirect_url =
					"https://www.carmella.co.il/%d7%a9%d7%99%d7%a8%d7%95%d7%aa-%d7%9c%d7%a7%d7%95%d7%97%d7%95%d7%aa/";
				try {
					redirect_url =
						window.wpData.home_url +
						"/%d7%a9%d7%99%d7%a8%d7%95%d7%aa-%d7%9c%d7%a7%d7%95%d7%97%d7%95%d7%aa/";
				} catch (err) {}
				window.location.href = redirect_url;
				// this.$modal.hide("office-core-slots-failed");
			}
		},
		components: {
			Close
		}
	};
</script>

<style scoped></style>
